export const ADD_PRODUCT_TO_CART = "ADD_PRODUCT_TO_CART";
export const REMOVE_PRODUCT_FROM_CART = "REMOVE_PRODUCT_FROM_CART";
export const INCREASE_CART_ITEM = "INCREASE_CART_ITEM";
export const DECREASE_CART_ITEM = "DECREASE_CART_ITEM";
export const SHOW_CART = "SHOW_CART";
export const HIDE_CART = "HIDE_CART";
export const GET_CURRENCIES = "GET_CURRENCIES";
export const CURRENCY_CHANGE = "CURRENCY_CHANGE";
export const UPDATE_CART_PRICE = "UPDATE_CART_PRICE";
